(() => {
  if (window.ballrInquiryTrackingV3) {
    window.ballrInquiryTrackingV3();
    return;
  }
  const pendingKey = 'ballr_inquiry_pending_v2';
  const formSelector = 'form[id="BallrOrganizationInquiryForm"], form[id="BallrShippingQuoteForm"]';
  const qaParams = new URLSearchParams(location.search);
  const qaEnabled = qaParams.get('inquiry_test') === '1' || qaParams.get('ballr_debug') === '1';
  const published = new Set();
  const sources = ['home', 'product', 'contact', 'football_landing', 'shipping_quote', 'cart'];
  const products = ['ballr-ai-sports-camera', 'ballr-ai-sports-camera-4-8m-tripod-set', '4-8m-tripod-portable-storage-bag'];
  const models = ['tripod', 'bundle-standard', 'bundle-4g', 'camera-standard', 'camera-4g'];
  const uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i;
  const consentState = () => {
    try {
      const value = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.();
      return typeof value === 'boolean' ? value : null;
    } catch { return null; }
  };
  const analyticsAllowed = () => consentState() === true;
  const consentLabel = () => consentState() === true ? 'allowed' : consentState() === false ? 'denied' : 'unknown';
  const qaLog = (phase, data = {}, pendingTest = false) => {
    if (!qaEnabled && pendingTest !== true) return;
    try { console.log('[Ballr inquiry QA] ' + JSON.stringify({phase, ...data})); } catch {}
  };
  const syncQaConsent = () => {
    if (!qaEnabled) return;
    const state = consentLabel();
    document.querySelectorAll(formSelector).forEach((form) => {
      if (form.dataset.ballrInquiryConsent === state) return;
      form.dataset.ballrInquiryConsent = state;
      qaLog('consent', {form_id: form.id, consent: state});
    });
  };
  let featureRequested = false;
  const preparePrivacy = (attempt = 0) => {
    syncQaConsent();
    if (consentState() !== null || attempt >= 40) return;
    const shop = window.Shopify;
    if (!featureRequested && typeof shop?.loadFeatures === 'function') {
      featureRequested = true;
      try {
        shop.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], (error) => {
          qaLog('privacy_api_load', {result: error ? 'failed' : 'completed'});
          syncQaConsent();
        });
      } catch {
        qaLog('privacy_api_load', {result: 'failed'});
      }
    }
    if (consentState() === null) setTimeout(() => preparePrivacy(attempt + 1), 250);
    else syncQaConsent();
  };
  const clearPending = () => {
    try { sessionStorage.removeItem(pendingKey); } catch {}
  };
  const readPending = () => {
    try { return JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); } catch { return null; }
  };
  const newId = () => {
    try { return crypto.randomUUID(); } catch { return ''; }
  };
  const init = () => {
    const params = new URLSearchParams(location.search);
    const test = params.get('inquiry_test') === '1' || params.get('ballr_debug') === '1';
    if (consentState() === false) clearPending();
    syncQaConsent();
    document.querySelectorAll(formSelector).forEach((form) => {
      if (form.dataset.ballrInquiryReady) return;
      form.dataset.ballrInquiryReady = 'true';
      const shipping = form.id === 'BallrShippingQuoteForm';
      const suppliedContext = form.querySelector('[data-inquiry-context]')?.value;
      const context = shipping ? (suppliedContext === 'drawer' ? 'drawer' : 'page') : 'organization';
      const path = location.pathname;
      const source = sources.includes(params.get('inquiry_source')) ? params.get('inquiry_source') : shipping ? (context === 'drawer' ? 'product' : 'shipping_quote') : 'contact';
      const product = products.includes(params.get('product')) ? params.get('product') : '';
      const variant = product && /^\d{1,20}$/.test(params.get('variant') || '') ? params.get('variant') : '';
      const writeField = (selector, value) => {
        const field = form.querySelector(selector);
        if (field) field.value = value;
      };
      const productData = () => {
        const choice = shipping ? form.querySelector('[data-quote-product]')?.value || '' : '';
        const model = models.includes(choice) ? choice : '';
        return {
          product: model.startsWith('camera-') ? products[0] : model.startsWith('bundle-') ? products[1] : model === 'tripod' ? products[2] : product,
          variant: shipping ? '' : variant,
          model
        };
      };
      writeField('[data-inquiry-source]', source);
      writeField('[data-inquiry-product]', product);
      writeField('[data-inquiry-variant]', variant);
      let submissionId = '';
      let started = false;
      let submitIntent = false;
      let invalidScheduled = false;
      const ensureId = () => {
        if (!submissionId) submissionId = newId();
        writeField('[data-inquiry-submission-id]', submissionId);
        return submissionId;
      };
      const diagnostic = (eventName, extra = {}) => {
        syncQaConsent();
        if (!analyticsAllowed()) {
          if (consentState() === false) clearPending();
          qaLog('diagnostic_skipped', {event_name: eventName, form_id: form.id, consent: consentLabel()});
          return false;
        }
        if (!uuid.test(ensureId())) return false;
        const eventId = newId();
        if (!uuid.test(eventId)) return false;
        const item = productData();
        const payload = {
          schema_version: 1,
          event_id: eventId,
          submission_id: submissionId,
          form_id: form.id,
          form_context: context,
          inquiry_type: shipping ? 'shipping_quote' : 'buying_inquiry',
          inquiry_source: source,
          product_handle: item.product,
          test_event: test,
          ...extra
        };
        try {
          const accepted = window.Shopify?.analytics?.publish?.(eventName, payload) === true;
          qaLog('diagnostic_publish', {event_name: eventName, form_id: form.id, event_id: eventId, submission_id: submissionId, accepted, ...extra});
          return accepted;
        } catch {
          qaLog('diagnostic_publish', {event_name: eventName, form_id: form.id, accepted: false});
          return false;
        }
      };
      const isEditable = (target) => target?.form === form && ['INPUT', 'SELECT', 'TEXTAREA'].includes(target.tagName) && !['hidden', 'submit', 'button', 'reset'].includes(target.type) && !target.disabled && !target.readOnly;
      const start = (event) => {
        qaLog('input_observed', {form_id: form.id, trusted: event.isTrusted === true, editable: isEditable(event.target), started});
        if (!event.isTrusted || !isEditable(event.target) || started) return;
        if (diagnostic('ballr_inquiry_started')) started = true;
      };
      form.addEventListener('input', start);
      form.addEventListener('change', start);
      const markIntent = (event) => {
        if (!event.isTrusted) return;
        const button = event.target?.closest?.('button, input[type="submit"], input[type="image"]');
        const clickedSubmit = event.type === 'click' && button?.form === form && (button.type === 'submit' || button.type === 'image');
        const pressedEnter = event.type === 'keydown' && event.key === 'Enter' && event.target?.tagName === 'INPUT' && isEditable(event.target);
        if (!clickedSubmit && !pressedEnter) return;
        submitIntent = true;
        setTimeout(() => { submitIntent = false; }, 0);
      };
      form.addEventListener('click', markIntent, true);
      form.addEventListener('keydown', markIntent, true);
      form.addEventListener('invalid', (event) => {
        if (!event.isTrusted || !submitIntent || invalidScheduled || !analyticsAllowed()) return;
        invalidScheduled = true;
        setTimeout(() => {
          invalidScheduled = false;
          diagnostic('ballr_inquiry_attempted', {attempt_status: 'invalid'});
        }, 0);
      }, true);
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        submissionId = '';
        started = false;
        submitIntent = false;
        invalidScheduled = false;
        writeField('[data-inquiry-submission-id]', '');
      });
      form.addEventListener('submit', (event) => {
        syncQaConsent();
        qaLog('submit_observed', {form_id: form.id, trusted: event.isTrusted === true, consent: consentLabel()});
        if (!event.isTrusted) return;
        if (!form.checkValidity()) {
          if (analyticsAllowed()) diagnostic('ballr_inquiry_attempted', {attempt_status: 'invalid'});
          return;
        }
        if (!uuid.test(ensureId())) return;
        if (!analyticsAllowed()) {
          if (consentState() === false) clearPending();
          return;
        }
        const id = submissionId;
        const item = productData();
        const pending = {
          id,
          formId: form.id,
          context,
          path,
          timestamp: Date.now(),
          source,
          product: item.product,
          variant: item.variant,
          model: item.model,
          language: document.documentElement.lang,
          test
        };
        try { sessionStorage.setItem(pendingKey, JSON.stringify(pending)); } catch {}
        queueMicrotask(() => {
          diagnostic('ballr_inquiry_attempted', {attempt_status: 'valid'});
        });
      });
      if (!form.querySelector('[data-ballr-inquiry-success]') || form.querySelector('[data-ballr-inquiry-errors]')) return;
      const pending = readPending();
      if (!pending || pending.formId !== form.id || pending.context !== context || pending.path !== path || !uuid.test(pending.id || '') || !Number.isFinite(pending.timestamp) || Date.now() - pending.timestamp > 3600000 || pending.timestamp > Date.now()) {
        qaLog('success_correlation', {form_id: form.id, matched: false}, pending?.test === true);
        return;
      }
      qaLog('success_correlation', {form_id: form.id, matched: true, submission_id: pending.id}, pending.test === true);
      const payload = {
        form_id: form.id,
        form_context: context,
        submission_id: pending.id,
        inquiry_type: shipping ? 'shipping_quote' : 'buying_inquiry',
        inquiry_source: sources.includes(pending.source) ? pending.source : shipping ? 'shipping_quote' : 'contact',
        product_handle: products.includes(pending.product) ? pending.product : '',
        variant_id: /^\d{1,20}$/.test(pending.variant || '') ? pending.variant : '',
        product_model: models.includes(pending.model) ? pending.model : '',
        language: /^[a-zA-Z-]{2,12}$/.test(pending.language || '') ? pending.language : '',
        test_event: pending.test === true || test,
        success: true
      };
      let attempts = 0;
      const publish = () => {
        syncQaConsent();
        const privacy = consentState();
        if (privacy === false) { clearPending(); return; }
        if (privacy !== true) {
          if (++attempts < 40) setTimeout(publish, 250);
          return;
        }
        if (published.has(pending.id)) return;
        const active = readPending();
        if (active?.id !== pending.id || active.formId !== form.id || active.context !== context) return;
        if (!window.Shopify?.analytics?.publish) {
          if (++attempts < 40) setTimeout(publish, 250);
          return;
        }
        try {
          const accepted = window.Shopify.analytics.publish('ballr_inquiry_submitted', payload) === true;
          qaLog('success_publish', {form_id: form.id, submission_id: pending.id, accepted}, pending.test === true);
          if (!accepted) {
            if (++attempts < 40) setTimeout(publish, 250);
            return;
          }
          published.add(pending.id);
          clearPending();
          form.dataset.ballrInquiryEvent = 'published';
        } catch {
          if (++attempts < 40) setTimeout(publish, 250);
        }
      };
      publish();
    });
  };
  window.ballrInquiryTrackingV3 = init;
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('visitorConsentCollected', () => {
    syncQaConsent();
    if (consentState() === false) clearPending();
  });
  init();
  preparePrivacy();
})();
